import Swiper, { Navigation, Pagination, Keyboard, Autoplay } from "swiper";
window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".c-text-image-card-slider .swiper").forEach(element => {
    const speed = element.dataset.speed ?? "slow";
    let sliderSpeed = 15000;
    if (speed === "medium") sliderSpeed = 10000;
    if (speed === "fast") sliderSpeed = 5000;
    const autoplay = element.dataset.auto === "false" ? false : {
      delay: sliderSpeed,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    };
    new Swiper(element, {
      modules: [Navigation, Pagination, Keyboard, Autoplay],
      loop: true,
      slidesPerView: 1,
      autoplay: autoplay,
      keyboard: {
        enabled: true
      },
      navigation: {
        nextEl: element.parentElement.querySelector(".swiper-button-next"),
        prevEl: element.parentElement.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: element.parentElement.querySelector(".swiper-pagination"),
        clickable: true
      },
      breakpoints: {
        834: {
          slidesPerView: 2
        },
        1180: {
          slidesPerView: 3
        },
        1390: {
          slidesPerView: 4
        }
      }
    });
  });
});